(function () {
  "use strict";

  angular
    .module("admin.rewards.service", [])
    .factory("RewardsService", RewardsService);

  /** @ngInject */
  function RewardsService($http, $q, API) {
    function list() {
      var defered = $q.defer();

      $http
        .get(API.API_URL + "admin/reward_types")
        .success(defered.resolve)
        .error(defered.reject);

      return defered.promise;
    }

    function listPublish(start, limit, sort) {
      var defered = $q.defer();

      $http
        .get(
          API.API_URL +
            "admin/reward_types/published?start=" +
            start +
            "&limit=" +
            limit +
            "&sort=" +
            sort
        )
        .success(defered.resolve);

      return defered.promise;
    }

    function listUnpublish(start, limit, sort) {
      var defered = $q.defer();

      $http
        .get(
          API.API_URL +
            "admin/reward_types/unpublished?start=" +
            start +
            "&limit=" +
            limit +
            "&sort=" +
            sort
        )
        .success(defered.resolve);

      return defered.promise;
    }

    function listArchived(start, limit, sort) {
      var defered = $q.defer();

      $http
        .get(
          API.API_URL +
            "admin/reward_types/archived?start=" +
            start +
            "&limit=" +
            limit +
            "&sort=" +
            sort
        )
        .success(defered.resolve);

      return defered.promise;
    }

    function get(id) {
      var defered = $q.defer();

      $http
        .get(API.API_URL + "admin/reward_types/" + id)
        .success(defered.resolve);

      return defered.promise;
    }

    function save(model) {
      var defered = $q.defer();

      $http
        .post(API.API_URL + "admin/reward_types", model)
        .success(defered.resolve)
        .error(defered.reject);

      return defered.promise;
    }

    function update(id, model) {
      var defered = $q.defer();

      $http
        .put(API.API_URL + "admin/reward_types/" + id, model)
        .success(defered.resolve)
        .error(defered.reject);

      return defered.promise;
    }

    function remove(id) {
      var defered = $q.defer();

      $http
        .delete(API.API_URL + "admin/reward_types/" + id)
        .success(defered.resolve)
        .error(defered.reject);

      return defered.promise;
    }

    function publish(id) {
      var defered = $q.defer();

      $http
        .post(API.API_URL + "admin/reward_types/" + id + "/publish")
        .success(defered.resolve)
        .error(function (result) {
          swal(result.error.message, "", "error");
        });

      return defered.promise;
    }

    function unpublish(id) {
      var defered = $q.defer();

      $http
        .post(API.API_URL + "admin/reward_types/" + id + "/unpublish")
        .success(defered.resolve)
        .error(function (result) {
          swal(result.error.message, "", "error");
        });

      return defered.promise;
    }

    function reorder(id, order) {
      var defered = $q.defer();

      $http
        .put(API.API_URL + "admin/reward_types/" + id + "/order/" + order)
        .success(defered.resolve)
        .error(defered.reject);

      return defered.promise;
    }

    function listBundlesAward(setId) {
      var defered = $q.defer();

      $http
        .get(API.API_URL + "admin/sets/" + setId + "/bundles/award")
        .success(defered.resolve)
        .error(defered.reject);

      return defered.promise;
    }

    function listTranslations(id) {
      var defered = $q.defer();

      $http
        .get(
          API.API_URL + "admin/reward_types/" + id + "/reward_type_translations"
        )
        .success(defered.resolve)
        .error(defered.reject);

      return defered.promise;
    }

    function getTranslation(id) {
      var defered = $q.defer();

      $http
        .get(API.API_URL + "admin/reward_type_translations/" + id)
        .success(defered.resolve);

      return defered.promise;
    }

    function saveTranslation(id, model) {
      var defered = $q.defer();

      $http
        .post(
          API.API_URL +
            "admin/reward_types/" +
            id +
            "/reward_type_translations?automatic=true",
          model
        )
        .success(defered.resolve)
        .error(defered.reject);

      return defered.promise;
    }

    function updateTranslation(id, model) {
      var defered = $q.defer();

      $http
        .put(
          API.API_URL +
            "admin/reward_type_translations/" +
            id +
            "?automatic=true",
          model
        )
        .success(defered.resolve)
        .error(defered.reject);

      return defered.promise;
    }

    function removeTranslation(id) {
      var defered = $q.defer();

      $http
        .delete(API.API_URL + "admin/reward_type_translations/" + id)
        .success(defered.resolve)
        .error(defered.reject);

      return defered.promise;
    }

    return {
      list: list,
      listPublish: listPublish,
      listUnpublish: listUnpublish,
      listArchived: listArchived,
      listBundlesAward: listBundlesAward,
      get: get,
      save: save,
      update: update,
      remove: remove,
      publish: publish,
      unpublish: unpublish,
      reorder: reorder,
      listTranslations: listTranslations,
      getTranslation: getTranslation,
      saveTranslation: saveTranslation,
      updateTranslation: updateTranslation,
      removeTranslation: removeTranslation,
    };
  }
})();
